import { ref } from "vue";

// Global flag used by:
// - main.ts errorHandler / unhandledrejection handler to swallow Frontegg's transient
//   "reading 'user'" error that fires while switchTenant is propagating
// - any future UI that wants to show a switching state
export const isSwitchingTenant = ref(false);

const TRANSIENT_MESSAGES = ["reading 'user'", 'reading "user"', "reading 'tenantId'", 'reading "tenantId"'];

export const isFronteggTransientError = (err: unknown): boolean => {
  if (!err) return false;
  const message =
    err instanceof Error
      ? err.message
      : typeof err === "string"
        ? err
        : typeof (err as { message?: unknown })?.message === "string"
          ? (err as { message: string }).message
          : "";
  return TRANSIENT_MESSAGES.some((needle) => message.includes(needle));
};
